export class ProfilePicture {
    picture: string;
}
